import { ApiResponse, Lead } from '../models';
import * as http from './http';
import ApiService from './service';

export class OrderService extends ApiService {
  async createOrder(data: { leadId: string; configId: string }) {
    const url = `${this.apiDomain}/api/order`;
    const response = await http.post<ApiResponse<Lead>>(url, data, this.store);
    return response.data;
  }

  async confirmOrder(data: { leadId: string; configId: string }) {
    const url = `${this.apiDomain}/api/order/confirm`;
    const response = await http.post<ApiResponse<Lead>>(url, data, this.store);
    return response.data;
  }
  async reConfirmOrder(data: { leadId: string; configId: string }) {
    const url = `${this.apiDomain}/api/order/re-confirm`;
    const response = await http.post<ApiResponse<Lead>>(url, data, this.store);
    return response.data;
  }
}
